import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var AudioRecordingServiceService = /** @class */ (function () {
    function AudioRecordingServiceService() {
        this._recorded = new Subject();
        this._recordingTime = new Subject();
        this._recordingFailed = new Subject();
    }
    AudioRecordingServiceService.prototype.getRecordedBlob = function () {
        return this._recorded.asObservable();
    };
    AudioRecordingServiceService.prototype.getRecordedTime = function () {
        return this._recordingTime.asObservable();
    };
    AudioRecordingServiceService.prototype.recordingFailed = function () {
        return this._recordingFailed.asObservable();
    };
    AudioRecordingServiceService.prototype.startRecording = function () {
        var _this = this;
        if (this.recorder) {
            // It means recording is already started or it is already recording something
            return;
        }
        this._recordingTime.next('00:00');
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
            _this.stream = s;
            _this.record();
        }).catch(function (error) {
            _this._recordingFailed.next();
        });
    };
    AudioRecordingServiceService.prototype.abortRecording = function () {
        this.stopMedia();
    };
    AudioRecordingServiceService.prototype.record = function () {
        var _this = this;
        this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
            type: 'audio',
            mimeType: 'audio/webm'
        });
        this.recorder.record();
        this.startTime = moment();
        this.interval = setInterval(function () {
            var currentTime = moment();
            var diffTime = moment.duration(currentTime.diff(_this.startTime));
            var time = _this.toString(diffTime.minutes()) + ':' + _this.toString(diffTime.seconds());
            _this._recordingTime.next(time);
        }, 1000);
    };
    AudioRecordingServiceService.prototype.toString = function (value) {
        var val = value;
        if (!value) {
            val = '00';
        }
        if (value < 10) {
            val = '0' + value;
        }
        return val;
    };
    AudioRecordingServiceService.prototype.stopRecording = function () {
        var _this = this;
        debugger;
        if (this.recorder) {
            this.recorder.stop(function (blob) {
                if (_this.startTime) {
                    var mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
                    _this.stopMedia();
                    _this._recorded.next({ blob: blob, title: mp3Name });
                }
            }, function () {
                _this.stopMedia();
                _this._recordingFailed.next();
            });
        }
    };
    AudioRecordingServiceService.prototype.stopMedia = function () {
        if (this.recorder) {
            this.recorder = null;
            clearInterval(this.interval);
            this.startTime = null;
            if (this.stream) {
                this.stream.getAudioTracks().forEach(function (track) { return track.stop(); });
                this.stream = null;
            }
        }
    };
    AudioRecordingServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AudioRecordingServiceService_Factory() { return new AudioRecordingServiceService(); }, token: AudioRecordingServiceService, providedIn: "root" });
    return AudioRecordingServiceService;
}());
export { AudioRecordingServiceService };
